import { FC, memo } from "react";
import MenuExamplesPopup from "@containers/MenuExamplesPopup";
import { useMenuExamplesPopupData } from "@apiHooks/useMenuExamplesPopupData";

interface TopTrendsMenuExamplePopupProps {
    fetch: (options: any) => Promise<any>;
    isShown: boolean;
    close: () => void;
    getExportData: (options: any) => void;
}

const TopTrendsMenuExamplePopup: FC<TopTrendsMenuExamplePopupProps> = ({
    fetch,
    isShown,
    close,
    getExportData,
}) => {
    const {
        download,
        tableData,
        sort,
        getMenuExamples,
        totalCountExamples,
        isLoading,
        handleSortColumn,
        searchQuery,
        handleChangeSearchQuery,
    } = useMenuExamplesPopupData({
        fetch,
        isShown,
        getExportData,
        downloadUrl: 'export top trends menu examples',
    });

    return (
        <MenuExamplesPopup
            isShown={isShown}
            close={close}
            download={download}
            tableData={tableData}
            isLoading={isLoading}
            totalCountExamples={totalCountExamples}
            getMenuExamples={getMenuExamples}
            sort={sort}
            handleSortColumn={handleSortColumn}
            searchQuery={searchQuery}
            handleChangeSearchQuery={handleChangeSearchQuery}
        />
    );
};

export default memo(TopTrendsMenuExamplePopup);
